// 업데이트 게시글 "확인함" 표시 - 로그인 없는 공개 게시판이라 서버에 읽음상태를 저장할
// 계정이 없어서, 방문자 브라우저의 localStorage에 읽은 글 id만 남긴다(2026-08-28,
// "확인한거 표시좀해줄수 있나?" 요청).
const STORAGE_KEY = 'adcare-read-updates';

export function getReadIds() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(arr) ? arr : []);
    } catch {
        return new Set();
    }
}

export function markAsRead(id) {
    try {
        const ids = getReadIds();
        ids.add(String(id));
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
    } catch {
        // localStorage 사용 불가(프라이빗 모드 등) 시 조용히 무시
    }
}
